<template>
  <div>
    <ul class="h5-footer-wrap">
      <li v-for="item in menuList" :key="item.id">
        <router-link
          :to="{ name: item.name }"
          :exact="item.exact"
          class="menu-item"
          :class="{ 'is-active': item.routerName.includes($route.name) }"
        >
          <img class="icon" :src="item.image" alt="" />
          <img class="active-icon" :src="item.activeImg" alt="" />
          <span class="text">{{ item.text }}</span>
        </router-link>
      </li>
    </ul>
    <!-- <button
      v-show="!isAuthenticated && !isWeChat"
      @click="openApp"
      class="open-app-btn"
    >
      打开魔果云课 App
    </button> -->
    <!-- app -->
    <!-- <button
      v-show="!isAuthenticated && isWeChat"
      @click="openApp"
      class="open-app-btn"
    >
      打开魔果云课 App
      <wx-open-launch-app
        style="
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          border-radius: 0.32rem;
          overflow: hidden;
        "
        id="launch-btn"
        appid="wxb509f86149696e36"
      >
        <script type="text/wxtag-template">
          <style>
            .btn-mobile {
              width: 500px;
              height: 200px;
              background: none;
              border: none;
            }
          </style>
          <button class="btn-mobile"></button>
        </script>
      </wx-open-launch-app>
    </button> -->
    <!-- 占位元素 -->
    <div class="seize-seat-ele"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import wx from "@saas/components/src/mixins/wx";
import { isWeChat } from "@saas/components/src";
const protocol = process.env.VUE_APP_DESKTOP_PROTOCAL || 'comettech://';
export default {
  // mixins: [wx],
  data: function () {
    return {
      menuList: [
        {
          id: 1,
          text: "探索",
          name: "Home",
          activeImg: require("../assets/img/h5-footer/home-active.png"),
          image: require("../assets/img/h5-footer/home.png"),
          exact: true,
          routerName: [],
        },
        {
          id: 2,
          text: "学习",
          name: "myCourse",
          activeImg: require("../assets/img/h5-footer/study-active.png"),
          image: require("../assets/img/h5-footer/study.png"),
          exact: false,
          routerName: ["myCourse", "liveCalendar"],
        },
        {
          id: 3,
          text: "我的",
          name: "MyInfo",
          activeImg: require("../assets/img/h5-footer/my-active.png"),
          image: require("../assets/img/h5-footer/my.png"),
          exact: false,
          routerName: [],
        },
      ],
      isWeChat: isWeChat(),
    };
  },
  mounted() {
    this.getProfile();
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
  },
  methods: {
    ...mapActions(["getProfile"]),
    openApp() {
      window.location.href = protocol + "openpage";
    },
  },
};
</script>

<style lang="scss" scoped>
.seize-seat-ele {
  height: $h5-footer-height;
}
.h5-footer-wrap {
  z-index: 9;
  position: fixed;
  width: 100%;
  bottom: 0;
  height: $h5-footer-height;
  background: #ffffff;
  border-radius: 0.43rem 0.43rem 0rem 0rem;
  border: 0.03rem solid #f2f4f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.19rem 1.6rem 0.21rem;
  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon,
    .active-icon {
      width: 0.64rem;
      height: 0.64rem;
      margin-bottom: 0.11rem;
    }
    .text {
      font-weight: 400;
      font-size: 0.32rem;
      color: #0d1400;
      line-height: 0.45rem;
    }
    .icon {
      display: block;
    }
    .active-icon {
      display: none;
    }
  }
  .is-active,
  .router-link-active {
    .text {
      color: #00c89d;
    }

    .icon {
      display: none;
    }
    .active-icon {
      display: block;
    }
  }
}
.open-app-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(0.4rem + #{$h5-footer-height});
  font-weight: 500;
  font-size: 0.37rem;
  color: #ffffff;
  line-height: 0.45rem;
  width: 3.52rem;
  height: 1.01rem;
  border-radius: 0.32rem;
  background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
}
</style>
